export default "/fonts/vendor/@fontsource/fraunces/files/fraunces-latin-ext-400-normal.woff2?ce9e0c5b44fdc5072e31f27ccfe5bf80";